import { hasAnalyticsConsent } from "./consent";

export function trackWhatsAppClick(ctaLocation) {
  if (!hasAnalyticsConsent()) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    whatsapp_cta_location: ctaLocation,
  });
}
